class DateRangeDropdown {
  constructor() {
    this.items = [
      {
        label: 'Last 7 Days',
        name: 'sevenDay',
        unit: 'day',
        selected: false,
      },
      {
        label: 'This Month',
        name: 'thisMonth',
        unit: 'day',
        selected: false,
      },
      {
        label: 'Last Month',
        name: 'lastMonth',
        unit: 'day',
        selected: false,
      },
      {
        label: 'Last 6 Months',
        name: 'halfYear',
        unit: 'month',
        selected: true,
      },
      {
        label: 'Year to Date',
        name: 'thisYear',
        unit: 'month',
        selected: false,
      },
      {
        label: 'Year over Year',
        name: 'multiYear',
        unit: 'year',
        selected: false,
      },
    ];
  }
}

class Granularities {
  // Granularities for megatable visualization dropdown
  constructor() {
    this.defaultGranularities = [
      { label: 'Daily', name: 'daily', selected: true, disabled: false },
      { label: 'Weekly', name: 'weekly', selected: false, disabled: false },
      { label: 'Monthly', name: 'monthly', selected: false, disabled: true },
      { label: 'Yearly', name: 'yearly', selected: false, disabled: true },
    ];
  }
}

class Networks {
  constructor(statType) {
    this.defaultNetworks = [
      { label: 'Narrativ', name: 'narrativ', selected: true },
      { label: 'Narrativ - Rakuten', name: 'rakuten', selected: false },
    ];

    // Currently backend doesn't support networks filter for product stats
    if (statType === 'product') {
      this.defaultNetworks[0].selected = false;
    } else if (statType === 'merchant') {
      this.defaultNetworks[1].selected = true;
    }
  }
}

class PubDashNetworks {
  constructor(statType) {
    this.defaultNetworks = [{ label: 'Narrativ', name: 'narrativ', selected: true }];

    // Currently backend doesn't support networks filter for product stats
    if (statType === 'product') {
      this.defaultNetworks[0].selected = false;
    } else if (statType === 'merchant') {
      this.defaultNetworks[1].selected = true;
    }
  }
}

class StatCache {
  constructor() {
    this.total_items = null;
    this.totals = null;
    this.pages = {}; // Store stats keyed on the backend page number
  }
}

export { DateRangeDropdown, Granularities, Networks, StatCache, PubDashNetworks };
